import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tab,
  Tabs,
  OverlayTrigger,
  Popover,
  PopoverTitle,
  Container,
  Modal,
  Row,
  Col,
} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFamilyList } from '../../utils/Coverage';
import AutoSuggestionSelectComponent from '../common/auto-suggestion-select/Select';
import AutoSuggestionSelectComponentAsync from '../common/auto-suggestion-select/AsyncSelect';
import GenericButton from '../common/button';
import './PriceCompare.scss';
import ProviderContainerSearchPage from './components/ProviderContainerSearchPage';
import TextInput from '../../../Components/GenericInputText/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigurationSVG } from '../../../Admin/img/GlobalSVG';
import { axiosInstance } from '../../../api/axios';
import APIEndpoints from '../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../Member/errorhandling/HttpErrorCodes';
import PriceCompareSearchSkeleton from './skeleton/PriceCompareSearchSkeleton';
import { MAXIMUM_FIND_PROVIDER_RADIUS } from '../../../constants';
import {
  setSearchProviderParams,
  setSearchParamsForUI,
  setAddress,
  setProviderType,
  reetSelectedCheckedItems,
  searchProviderFiltersInitial,
  setNetworkTierList,
} from '../../../redux/member/priceCompareSlice';
import { getPriceComaperFilters } from '../../../redux/member/api-calls/priceCompare';
import { ChooseNetwork } from './choose-network';
import '../pricecompare/components/ProcedureProviderContainer.scss';
import ProviderImage from '../../img/pricecompare/provider.svg';
import ClaimDetailsInfoImage from '../../img/claim_details/Info.svg';
import { MAXIMUM_FIND_PRICE_COMPARE_RADIUS } from 'src/constants';
import { getMemberDetailsByOidAndType } from 'src/redux/admin/api-calls/members';

const PriceCompareSearch = ({ label, setProcedureForDataParent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let CoveredCostComparePriceArray = [];
  const {
    Display_Network_For_PriceComparison_Member,
    Value_Network_For_PriceComparison_Member,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const { Find_Provider_Network } = useSelector(
    (state) => state?.app?.customNetwork,
  );
  const { searchParamsForUI, searchProviderParams, providerType } = useSelector(
    (state) => state.priceCompare,
  );
  const { HealthProcedureCodes } = useSelector(
    ({ priceCompare }) => priceCompare,
  );
  const { PriceComparison_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const disclaimerText = PriceComparison_Setting.Disclaimer;
  const billedAmountForMember =
    PriceComparison_Setting?.Display_Billed_Amount_Member;

  const useZakiPointAPI = PriceComparison_Setting?.ENABLE_ZPH_INTEGRATION;

  //Data calculation for "Procedure For" dropdown
  const {
    loggedInUserOID,
    loggedInMemberType,
    employeeInfo,
    dependentsInfo,
    contactDetails,
  } = useSelector((state) => state.memberSummary);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 4,
  });

  const procedureForInfo = getFamilyList(
    employeeInfo,
    dependentsInfo,
    loggedInMemberType,
    loggedInUserOID,
  );

  //Data Calculation for Types or Speciality Field and ByType - ByName Field
  const searchNames = async (input) => {
    try {
      if (!input || input.length < 3) {
        return [];
      }
      const doctorBy =
        providerByData === 'doctor-type'
          ? APIEndpoints.getDoctorTypeSuggestions()
          : APIEndpoints.getDoctorNameSuggestions();
      const address =
        providerByData === 'doctor-name' ? 'useraddress/' + locationData : '';
      const url =
        doctorBy +
        input +
        '/pagenumber/1/pagesize/10/' +
        (locationData ? address : '') +
        ('/maximumradius/' + MAXIMUM_FIND_PROVIDER_RADIUS);
      const response = await axiosInstance.get(url);
      const namesList = [...response.data.Response.SearchDoctors].map((val) => {
        return { label: val, value: val };
      });
      namesList.unshift({ label: input, value: input });
      return namesList;
    } catch (error) {
      console.log(error);
      return [{ label: input, value: input }];
    }
  };
  const searchFacilityNames = async (input) => {
    try {
      if (!input || input.length < 3) {
        return [];
      }
      const facilityBy =
        providerByData === 'facility-type'
          ? APIEndpoints.getFacilityTypeSuggestions()
          : APIEndpoints.getFacilityNameSuggestions();
      const address =
        providerByData === 'facility-name' ? 'useraddress/' + locationData : '';
      const url =
        facilityBy +
        input +
        '/pagenumber/1/pagesize/10/' +
        (locationData ? address : '') +
        ('/maximumradius/' + MAXIMUM_FIND_PROVIDER_RADIUS);
      const response = await axiosInstance.get(url);
      const namesList =
        providerByData === 'facility-type'
          ? [...response.data.Response.SearchDoctors].map((val) => {
              return { label: val, value: val };
            })
          : [...response.data.Response.SearchFacilities].map((val) => {
              return { label: val, value: val };
            });
      namesList.unshift({ label: input, value: input });
      return namesList;
    } catch (error) {
      console.log(error);
      return [{ label: input, value: input }];
    }
  };
  const searchProcedureData = async (input) => {
    const formatter = (str) => {
      const words = str?.split(' ');
      const retSrt = words
        ?.map((item) => {
          return (
            item?.substring(0, 1)?.toUpperCase() +
            item?.substring(1)?.toLowerCase()
          );
        })
        ?.join(' ');
      return retSrt;
    };
    try {
      if (!input || input.length < 3) {
        return [];
      }
      const apiUrl = useZakiPointAPI
        ? APIEndpoints.getZakiPointProcedureCode()
        : APIEndpoints.getProcedureCodes();
      const response = await axiosInstance.get(`${apiUrl}${input}`);
      const namesList = [...response.data.Response.HealthProcedureCodes].map(
        (item) => {
          const viewLabel = `${formatter(item.Description)} \n${
            item?.CodeSetName ? item?.CodeSetName + ' ' : ''
          }${item.Code}`;
          return {
            label: viewLabel,
            value: item?.Code,
            codeName: item?.CodeSetName,
          };
        },
      );
      return namesList;
    } catch (error) {
      console.log(error);
    }
  };

  const procedureForOptionList = procedureForInfo?.filter(
    (item) => !item?.value?.includes('Family'),
  );
  const procedureForDefaultSelected =
    procedureForOptionList?.filter(
      (item) => item?.value === loggedInUserOID,
    )[0] || {};

  //Data calculation for "Location" field
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [loader, setLoader] = useState(true);
  const [activeId, setActiveId] = useState(false);
  const [isOpenDisclaimerPopup, setisOpenDisclaimerPopup] = useState(false);

  const getMyProfileDetails = async () => {
    console.log('getMyProfileDetails called');
    try {
      //const response = await axiosInstance.get(
      //`${APIEndpoints.getMyProfileDetailsResource()}${loggedInMemberType}/oid/${loggedInUserOID}`,
      //);

      const response = await getMemberDetailsByOidAndType(
        loggedInUserOID,
        loggedInMemberType,
      );

      console.log('temp log response', response);

      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response?.status) {
        if (
          response?.data?.Response?.Member?.ContactDetails &&
          response?.data?.Response?.Member?.ContactDetails?.Address &&
          response?.data?.Response?.Member?.ContactDetails?.Address[0] &&
          response?.data?.Response?.Member?.ContactDetails?.Address[0]
            ?.PostalCode
        ) {
          setLocationData(
            response?.data?.Response?.Member?.ContactDetails?.Address[0]
              ?.PostalCode,
          );
        } else {
          setLocationData('');
        }
      }
      setIsAPIFailed(false);
      setIsNotFound(false);
      setLoader(false);
      return Promise.resolve(response);
    } catch (error) {
      setLoader(false);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    }
  };

  const toggleActive = (id) => {
    setActiveId(!activeId);
  };

  useEffect(() => {
    if (!searchParamsForUI?.locationData) {
      setLoader(true);
      if (
        contactDetails &&
        contactDetails?.Address &&
        contactDetails?.Address[0] &&
        contactDetails?.Address[0]?.PostalCode
      ) {
        setLocationData(contactDetails?.Address[0]?.PostalCode);
        setLoader(false);
      } else {
        (async () => {
          try {
            await getMyProfileDetails();
          } catch (error) {
            console.log(error);
          }
        })();
      }
      setLoader(false);
    }
    setLoader(false);
    return () => {
      if (!location.pathname.includes('price-compare')) {
        //dispatch( resetSearchProviderFilters() );
      }
    };
  }, []);

  const pageInfo = useRef(null);
  const providerSettingsRef = useRef();
  const transactionTypeOptions = HealthProcedureCodes;

  const [procedureForData, setProcedureForData] = useState(
    searchParamsForUI?.procedureForData
      ? searchParamsForUI?.procedureForData
      : procedureForDefaultSelected,
  );
  const [helthProcedureData, setHelthProcedureData] = useState(
    searchParamsForUI?.helthProcedureData
      ? searchParamsForUI?.helthProcedureData
      : '',
  );
  const [billedamount, setbilledamount] = useState(
    searchParamsForUI?.billedamount ? searchParamsForUI?.billedamount : '',
  );
  const [locationData, setLocationData] = useState(
    searchParamsForUI?.locationData ? searchParamsForUI?.locationData : '',
  );
  const [providerByData, setProviderByData] = useState(
    searchParamsForUI?.filters?.providerByData
      ? searchParamsForUI?.filters?.providerByData
      : searchParamsForUI?.providerByData
      ? searchParamsForUI?.providerByData
      : 'doctor-type',
  );
  const [typesOfSpecialtyData, setTypesOfSpecialtyData] = useState(
    searchParamsForUI?.typesOfSpecialtyData
      ? searchParamsForUI?.typesOfSpecialtyData
      : '',
  );
  const [networksData, setNetworksData] = useState(
    searchParamsForUI?.networksData || {
      label: 'All Plan Networks',
      value: 'all-plan-networks',
      AllowForPriceComparison: 'Y',
      ProviderDirectory: 'I',
      ExternalName: '',
    },
  );
  const [acceptNewPatientsData, setAcceptNewPatientsData] = useState(
    searchProviderParams.AcceptingNewPatients
      ? searchProviderParams.AcceptingNewPatients
      : false,
  );
  const [addFilterVisible, setAddFilterVisible] = useState(false);
  const [expand, setExpand] = useState(false);
  const [networkDropdownListData, setNetworkDropdownListData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    searchProviderParams.filters.Provider === 'facility'
      ? 'Facility'
      : 'Doctor',
  );
  const addFiltersInitialState = {
    gender: '',
    distance: '',
    language: [
      { lang: 'japanese', checked: false },
      { lang: 'english', checked: false },
      { lang: 'french', checked: false },
      { lang: 'spanish', checked: false },
    ],
  };
  const [addFilterData, setAddFilterData] = useState(addFiltersInitialState);

  const locationHandler = (event) => {
    setLocationData(event.target.value.replace(/  +/g, ' '));
  };

  function validateNumberInput(inputNumber) {
    return inputNumber.search(/^[0-9]{0,4}.?[0-9]{0,2}$/) == 0 ? true : false;
  }

  const billedAmountHandler = (event) => {
    const amount = event.target.value;
    if (/^[0-9]{0,9}.?[0-9]{0,2}$/.test(amount) && amount !== '') {
      if (amount !== '.00') {
        if (!isNaN(parseFloat(amount))) {
          setbilledamount(amount);
        }
      } else {
        setbilledamount('');
      }
    } else {
      setbilledamount('');
    }

    //.  scenario
  };

  const formatBilledAmount = () => {
    const answerVal = Number.parseFloat(billedamount).toFixed(2);
    if (isNaN(answerVal)) {
      setbilledamount('');
    } else {
      const beforeDec = answerVal.split('.')[0];
      if (beforeDec.length > 9) {
        const trimAmount = beforeDec.slice(0, -3);
        const roundedVal = Number.parseFloat(trimAmount).toFixed(2);
        setbilledamount(roundedVal);
      } else {
        setbilledamount(answerVal);
      }
    }
  };

  const handleMemberChangeNetworkSideEffect = (procedureForData) => {
    getMyProfileDetails(procedureForData);

    if (Display_Network_For_PriceComparison_Member === true) {
      if (Value_Network_For_PriceComparison_Member === 'network') {
        getNetworkTierOptions('network');
      } else {
        getNetworkTierOptions('tier');
      }
    } else {
      setNetworkDropdownListData([
        {
          label: 'All Plan Networks',
          value: 'all-plan-networks',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        },
        {
          label: 'All - Including Out of Network Providers',
          value: 'all-include-out-of-network',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        },
      ]);
    }
    if (Display_Network_For_PriceComparison_Member !== true) {
      setNetworksData({
        label: 'All Plan Networks',
        value: 'all-plan-networks',
        AllowForPriceComparison: 'Y',
        ProviderDirectory: 'I',
        ExternalName: '',
      });
    }
  };

  const handleMemberChangeEvent = (e) => {
    console.log('e--', e);
    setProcedureForData(e);
    setProcedureForDataParent(e);
    setLocationData('');
    //dispatch(setSearchParamsForUI({ procedureForData: e }));
    getMyProfileDetails(e);
  };

  const handleSearchResult = () => {
    CoveredCostComparePriceArray = [];
    console.log('Search Api Calling with patameters :', {
      procedureForData,
      helthProcedureData,
      locationData,
      providerByData,
      typesOfSpecialtyData,
      acceptNewPatientsData,
      addFilterData,
      addFilterData,
      networksData,
    });
    dispatch(searchProviderFiltersInitial());
    dispatch(setAddress(locationData));
    dispatch(setProviderType(selectedTab === 'Doctor' ? 'doctor' : 'facility'));
    dispatch(
      setSearchParamsForUI({
        procedureForData,
        helthProcedureData,
        locationData,
        providerByData,
        networksData: networksData || {
          label: 'All Plan Networks',
          value: 'all-plan-networks',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        },
        typesOfSpecialtyData,
        acceptNewPatientsData: false,
        billedamount,
        filters: { providerByData },
      }),
    );

    if (selectedTab === 'Doctor') {
      if (providerByData === 'doctor-type') {
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            pagesize: 10,
            DoctorByType: typesOfSpecialtyData?.value,
            DoctorByName: null,
            AcceptingNewPatients: false,
            Network: networksData?.value,
            filters: {
              Provider: 'doctor',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      } else {
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            pagesize: 10,
            DoctorByType: null,
            DoctorByName: typesOfSpecialtyData?.value,
            AcceptingNewPatients: false,
            Network: networksData?.value,
            filters: {
              Provider: 'doctor',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      }
    } else {
      if (providerByData === 'facility-type') {
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            pagesize: 10,
            speciality: typesOfSpecialtyData?.value,
            facilityname: null,
            AcceptingNewPatients: false,
            Network: networksData?.value,
            filters: {
              Provider: 'facility',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      } else {
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            pagesize: 10,
            speciality: null,
            facilityname: typesOfSpecialtyData?.value,
            AcceptingNewPatients: false,
            Network: networksData?.value,
            filters: {
              Provider: 'facility',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      }
    }
    dispatch(getPriceComaperFilters());
    navigate('/member/price-compare/search-results', {
      state: {
        procedureForData,
        helthProcedureData,
        locationData,
        providerByData,
        typesOfSpecialtyData,
        addFilterData,
        billedamount,
        CoveredCostComparePriceArray,
      },
    });
  };

  const groupBy = function (xs, key) {
    return xs.reduce((rv, x) => {
      //if(Find_Provider_Network && Find_Provider_Network.map(a => a.NetworkName).includes(x.value)) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      //}
      return rv;
    }, {});
  };
  const getNetworkTierOptions = async (dropdownID) => {
    const defaultNetworks = [
      {
        label: 'All Plan Networks',
        value: 'all-plan-networks',
        AllowForPriceComparison: 'Y',
        ProviderDirectory: 'I',
        ExternalName: '',
      },
      {
        label: 'All - Including Out of Network Providers',
        value: 'all-include-out-of-network',
        AllowForPriceComparison: 'Y',
        ProviderDirectory: 'I',
        ExternalName: '',
      },
    ];
    try {
      const response = await axiosInstance.get(
        `${APIEndpoints.getNetworkTierPriceCompareData()}${
          procedureForData?.memberType == 'Member'
            ? 'employee'
            : procedureForData?.memberType
        }/oid/${procedureForData?.value}`,
      );
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response?.status) {
        if (response?.data?.Response?.PriceCompareNetworkTeirInfo?.length > 0) {
          const responseData =
            response?.data?.Response?.PriceCompareNetworkTeirInfo;
          const commonNetworks = [];
          console.log('responseData', responseData);
          if (dropdownID === 'network') {
            const filteredDataWithNetwprkCode = responseData.filter(
              (item) => item.NetworkCode !== null,
            );
            const uniqueResponseData = [];

            for (let i = 0; i < filteredDataWithNetwprkCode.length; i++) {
              if (
                !uniqueResponseData.find(
                  (item) =>
                    item.NetworkCode ===
                    filteredDataWithNetwprkCode[i].NetworkCode,
                )
              ) {
                uniqueResponseData.push(filteredDataWithNetwprkCode[i]);
              }
            }
            for (let i = 0; i < Find_Provider_Network?.length; i++) {
              for (let j = 0; j < uniqueResponseData?.length; j++) {
                if (
                  Find_Provider_Network[i]?.NetworkID ===
                    uniqueResponseData[j]?.NetworkCode &&
                  uniqueResponseData[j]?.NetworkDescription &&
                  Find_Provider_Network[i]?.Portal_Display_Label
                ) {
                  commonNetworks.push({
                    label: Find_Provider_Network[i]?.Portal_Display_Label,
                    value: uniqueResponseData[j]?.NetworkDescription,
                    isTier: false,
                    ProviderDirectory: uniqueResponseData[j]?.ProviderDirectory,
                    AllowForPriceComparison:
                      uniqueResponseData[j]?.AllowForPriceComparison,
                    ExternalName: uniqueResponseData[j]?.ExternalName,
                    NetworkCode: uniqueResponseData[j]?.NetworkCode,
                  });
                }
              }
            }
            dispatch(setNetworkTierList(commonNetworks));
          } else if (dropdownID === 'tier' && responseData?.length > 0) {
            const filteredDataWithNetwprkCode = responseData.filter(
              (item) => item.NetworkCode !== null,
            );
            const uniqueResponseData = [];

            for (let i = 0; i < filteredDataWithNetwprkCode.length; i++) {
              if (
                !uniqueResponseData.find(
                  (item) =>
                    item.NetworkCode ===
                    filteredDataWithNetwprkCode[i].NetworkCode,
                )
              ) {
                uniqueResponseData.push(filteredDataWithNetwprkCode[i]);
              }
            }
            uniqueResponseData.map((item) => {
              if (
                item?.NetworkTier &&
                item?.NetworkDescription &&
                item.NetworkCode !== null
              ) {
                commonNetworks.push({
                  label: item?.NetworkTier,
                  value: item?.NetworkDescription,
                  ProviderDirectory: item?.ProviderDirectory,
                  AllowForPriceComparison: item?.AllowForPriceComparison,
                  ExternalName: item?.ExternalName,
                });
              }
            });
            const uniqueItems = [];
            const groupByNetwork = groupBy(commonNetworks, 'label');
            const tierArr = Object.keys(groupByNetwork);

            for (let i = 0; i < tierArr.length; i++) {
              const allnetwork = groupByNetwork[tierArr[i]];
              uniqueItems.push({
                label: tierArr[i],
                value: allnetwork.map((x) => x.value).join(','),
                isTier: true,
                AllowForPriceComparison: allnetwork.map(
                  (x) => x.AllowForPriceComparison,
                )[0],
                ExternalName: allnetwork.map((x) => x.ExternalName)[0],
                ProviderDirectory: allnetwork.map(
                  (x) => x.ProviderDirectory,
                )[0],
              });
            }
            uniqueItems.sort((a, b) => a.label.localeCompare(b.label));
            commonNetworks.splice(0, commonNetworks.length);
            commonNetworks.push(...uniqueItems);
            dispatch(setNetworkTierList(uniqueResponseData));
          }
          console.log('commonNetworks', commonNetworks);

          //here selected default network
          commonNetworks?.length > 0
            ? setNetworkDropdownListData([
                ...defaultNetworks,
                ...commonNetworks,
              ])
            : setNetworkDropdownListData([...defaultNetworks]);
          if (searchParamsForUI?.networksData?.value) {
            if (
              [...defaultNetworks, ...commonNetworks].find(
                (ele) => ele.value === searchParamsForUI?.networksData?.value,
              )?.value
            ) {
              setNetworksData(searchParamsForUI?.networksData);
            } else {
              setNetworksData(defaultNetworks[0]);
            }
          } else if (commonNetworks?.length === 0) {
            setNetworksData(defaultNetworks[0]);
          } else {
            if (
              commonNetworks.findIndex((x) => x.value == networksData.value) < 0
            ) {
              setNetworksData(defaultNetworks[0]);
            }
          }
        } else {
          setNetworkDropdownListData([...defaultNetworks]);
          setNetworksData(defaultNetworks[0]);
        }
      } else {
        setNetworkDropdownListData([...defaultNetworks]);
        setNetworksData(defaultNetworks[0]);
      }
    } catch (err) {
      setNetworkDropdownListData([...defaultNetworks]);
      setNetworksData(defaultNetworks[0]);
    }
    return [];
  };

  useEffect(() => {
    setTimeout(() => {
      pageInfo.current.focus();
    }, 10);
  }, []);

  const addFilterHandler = () => {
    setAddFilterVisible(false);
  };

  useEffect(() => {
    if (procedureForData?.memberType && procedureForData?.value) {
      if (Display_Network_For_PriceComparison_Member === true) {
        if (Value_Network_For_PriceComparison_Member === 'network') {
          getNetworkTierOptions('network');
        } else {
          getNetworkTierOptions('tier');
        }
      } else {
        setNetworkDropdownListData([
          {
            label: 'All Plan Networks',
            value: 'all-plan-networks',
            AllowForPriceComparison: 'Y',
            ProviderDirectory: 'I',
            ExternalName: '',
          },
          {
            label: 'All - Including Out of Network Providers',
            value: 'all-include-out-of-network',
            AllowForPriceComparison: 'Y',
            ProviderDirectory: 'I',
            ExternalName: '',
          },
        ]);
      }
      if (Display_Network_For_PriceComparison_Member !== true) {
        setNetworksData({
          label: 'All Plan Networks',
          value: 'all-plan-networks',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        });
      }
    } else {
      setNetworkDropdownListData([
        {
          label: 'All Plan Networks',
          value: 'all-plan-networks',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        },
        {
          label: 'All - Including Out of Network Providers',
          value: 'all-include-out-of-network',
          AllowForPriceComparison: 'Y',
          ProviderDirectory: 'I',
          ExternalName: '',
        },
      ]);
      setNetworksData({
        label: 'All Plan Networks',
        value: 'all-plan-networks',
        AllowForPriceComparison: 'Y',
        ProviderDirectory: 'I',
        ExternalName: '',
      });
    }
  }, [procedureForData]);

  const MAX_LIMIT = 1000;
  const tabClickHandler = (e) => {
    setSelectedTab(e);
    if (e === 'Doctor') {
      setProviderByData('doctor-type');
    }
    if (e === 'Facility') {
      setProviderByData('facility-type');
    }
    setTypesOfSpecialtyData('');
  };
  const handleButton = () => {
    setExpand(!expand);
    setTimeout(() => {
      providerSettingsRef?.current?.focus();
    }, 1000);
  };
  const handleClose = () => {
    setisOpenDisclaimerPopup(false);
  };

  useEffect(() => {
    dispatch(
      setSearchProviderParams({
        selectedNetwork: networksData,
      }),
    );
  }, [networksData]);

  return (
    <div
      className={
        label === 'modify search'
          ? 'price-comparison-container container p-0'
          : 'p-0'
      }
    >
      <div className="px-0">
        <div className="header-wrapper">
          <h1 className="content-header">
            {t('member.price_comparison.heading_text_compare')}{' '}
            <span className="content-header-bold">
              {t('member.price_comparison.heading_text_price')}
            </span>
          </h1>
          <span
            className="sr-only"
            role="heading"
            aria-level={1}
            tabIndex={-1}
            ref={pageInfo}
          >
            {t('member.price_comparison.accessibility_page_info')}
          </span>
        </div>
        <div className="price-compare-sub-text-on-main">
          {t('member.price_comparison.page_sub_heading')}{' '}
          {/*<a aria-hidden="true" className="learn-more">
            {t('member.price_comparison.learn_more')}
          </a> */}
        </div>
        {!loader ? (
          <>
            <ProviderContainerSearchPage
              text={t(
                'member.price_comparison.procedure_container.container_text',
              )}
              textPostfix={t(
                'member.price_comparison.procedure_container.container_textPostfix',
              )}
              wrapperClass="top-border-radius mt-3"
            >
              <div className="third-container-wrapper">
                <div className="common-third-container">
                  <div className="service-container">
                    <div className="first-input-wrapper">
                      <div>
                        <span className="input-top-text">
                          {t(
                            'member.price_comparison.procedure_container.procedure_dropdown_label',
                          )}{' '}
                          <span
                            className="required-label-star"
                            aria-hidden={true}
                          >
                            *
                          </span>{' '}
                          <span className="sr-only">required</span>
                        </span>
                        <AutoSuggestionSelectComponent
                          options={
                            procedureForOptionList?.length > 0
                              ? procedureForOptionList
                              : []
                          }
                          components={{ IndicatorSeparator: () => null }}
                          value={procedureForData}
                          onChange={(e) => {
                            handleMemberChangeEvent(e);
                          }}
                          isSearchable={false}
                          inputClassName="procedure-for-dropdown"
                          id="procedureForDropdown"
                          labelText={t(
                            'member.price_comparison.procedure_container.procedure_dropdown_labelText',
                          )}
                        />
                      </div>
                    </div>
                    <div className="second-input-wrapper">
                      <div className="third-container-wrapper">
                        <span className="input-top-text">
                          {t(
                            'member.price_comparison.procedure_container.health_procedure_dropdown_label',
                          )}
                          <span aria-hidden={true}>
                            {t(
                              'member.price_comparison.procedure_container.health_procedure_dropdown_label_postfix',
                            )}
                          </span>{' '}
                          <span
                            className="required-label-star"
                            aria-hidden={true}
                          >
                            *
                          </span>
                          <span className="sr-only">required</span>
                        </span>
                        <AutoSuggestionSelectComponentAsync
                          placeholder={t(
                            'member.price_comparison.procedure_container.health_procedure_dropdown_placeholder',
                          )}
                          components={{ IndicatorSeparator: () => null }}
                          value={helthProcedureData}
                          onChange={(e) => {
                            setHelthProcedureData(e);
                          }}
                          //id="healthProcedureDropdown"
                          clearable={true}
                          inputClassName="generic-select-prefix__clear-indicator"
                          labelText={t(
                            'member.price_comparison.procedure_container.health_procedure_dropdown_labelText',
                          )}
                          fetchOptions={searchProcedureData}
                        />
                        <span className="procedure-select-hint">
                          {t(
                            'member.price_comparison.procedure_container.health_procedure_hintText',
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ProviderContainerSearchPage>
            {billedAmountForMember === true && (
              <>
                <ProviderContainerSearchPage
                  text={t(
                    'member.price_comparison.procedure_container.more_options_label',
                  )}
                  wrapperClass="mt-1 "
                >
                  <div className="third-container-wrapper">
                    <div className="common-third-container">
                      <div className="service-container">
                        <div className="first-input-wrapper">
                          <div className="">
                            <div>
                              <span className="sr-only">Information : </span>
                              <span className="sr-only">
                                {t(
                                  'member.price_comparison.procedure_container.amount_tooltip_title',
                                )}
                              </span>
                              <span className="sr-only">
                                {t(
                                  'member.price_comparison.procedure_container.amount_tooltip_content',
                                )}
                              </span>
                              <span
                                id="moreoptionsLabel"
                                className="input-top-text"
                                aria-hidden={true}
                              >
                                {t(
                                  'member.price_comparison.procedure_container.more_options_label',
                                )}
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 200, hide: 450 }}
                                  overlay={
                                    <Popover>
                                      <PopoverTitle className="popover-resource-title">
                                        {t(
                                          'member.price_comparison.procedure_container.amount_tooltip_title',
                                        )}
                                      </PopoverTitle>
                                      <Popover.Content>
                                        {t(
                                          'member.price_comparison.procedure_container.amount_tooltip_content',
                                        )}
                                      </Popover.Content>
                                    </Popover>
                                  }
                                >
                                  <span
                                    className="required-label-star pl-2"
                                    aria-hidden={true}
                                  >
                                    <img
                                      src={ClaimDetailsInfoImage}
                                      alt="Info"
                                      tabIndex={0}
                                    />
                                  </span>
                                </OverlayTrigger>
                              </span>

                              <TextInput
                                parentClassName="mb-2 find-care-address mt-1"
                                inputProps={{
                                  //type: 'text',
                                  placeholder: t(
                                    'member.price_comparison.procedure_container.more_options_placeholder',
                                  ),
                                  value: billedamount || '',
                                  onChange: billedAmountHandler,
                                  onBlur: formatBilledAmount,
                                  //id: 'locationForProvider'
                                }}
                                ariaDescribedby="moreoptionsLabel"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ProviderContainerSearchPage>
              </>
            )}
            <ProviderContainerSearchPage
              img={ProviderImage}
              text={t(
                'member.price_comparison.provider_container.container_text',
              )}
              wrapperClass="bottom-border-radius mt-1"
            >
              <div className="third-container-wrapper">
                <div className="common-third-container">
                  <div className="provider-container">
                    <div className="first-input-wrapper">
                      <span id="locationLabel" className="input-top-text">
                        {t(
                          'member.price_comparison.provider_container.location_dropdown_label',
                        )}{' '}
                        <span
                          className="required-label-star"
                          aria-hidden={true}
                        >
                          *
                        </span>
                        <span className="sr-only">required</span>
                      </span>
                      <label className="sr-only" htmlFor="locationForProvider">
                        {t(
                          'member.price_comparison.provider_container.location_dropdown_labelText',
                        )}
                      </label>
                      <TextInput
                        parentClassName="mb-2 find-care-address"
                        inputProps={{
                          type: 'text',
                          placeholder: t('member.price_comparison.zip'),
                          value: locationData || '',
                          onChange: locationHandler,
                          id: 'locationForProvider',
                        }}
                        ariaDescribedby="locationLabel"
                        isRequired={true}
                      />
                    </div>
                    <div className="first-input-wrapper1">
                      <div className="network-container">
                        <span className="input-top-text">
                          {Display_Network_For_PriceComparison_Member &&
                          Value_Network_For_PriceComparison_Member === 'tier'
                            ? t(
                                'member.price_comparison.provider_container.networks_dropdown_labelTier',
                              )
                            : t(
                                'member.price_comparison.provider_container.networks_dropdown_label',
                              )}
                        </span>
                        <ChooseNetwork
                          customOptions={
                            networkDropdownListData?.length > 0
                              ? networkDropdownListData
                              : []
                          }
                          onChange={(e) => {
                            setNetworksData(e);
                          }}
                          value={networksData}
                          inputClassName="networks-dropdown-price-compare"
                          id="provider-network"
                          labelText={
                            Display_Network_For_PriceComparison_Member &&
                            Value_Network_For_PriceComparison_Member === 'tier'
                              ? t(
                                  'member.price_comparison.provider_container.networks_dropdown_labelTextTier',
                                )
                              : t(
                                  'member.price_comparison.provider_container.networks_dropdown_labelText',
                                )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {!expand && (
                  <div
                    className="button-position"
                    ref={providerSettingsRef}
                    tabIndex={-1}
                  >
                    <GenericButton
                      variant="link"
                      onClick={() => {
                        handleButton();
                      }}
                    >
                      {t('member.price_comparison.provider_settings')}
                    </GenericButton>
                  </div>
                )}
                {expand && (
                  <div className="common-third-container">
                    <Tabs
                      defaultActiveKey={selectedTab}
                      id="uncontrolled-tab-example"
                      className="vmTabs admin-member-nav-tabs"
                      onSelect={tabClickHandler}
                    >
                      <Tab
                        eventKey="Doctor"
                        title={
                          <span className="tab-header">
                            {t('member.price_comparison.doctor_label')}
                          </span>
                        }
                      >
                        <div className="second-input-wrapper">
                          <div className="serach-container">
                            <div className="search-text-container">
                              {t('member.price_comparison.search')}
                            </div>
                            <div className="spaciality-by-container">
                              <div className="d-flex align-items-center">
                                <input
                                  className="my-auto"
                                  type="radio"
                                  name="location"
                                  id="doctor-type"
                                  value="doctor-type"
                                  onChange={(e) => {
                                    setTypesOfSpecialtyData('');
                                    e.target.checked
                                      ? setProviderByData('doctor-type')
                                      : setProviderByData('');
                                  }}
                                  checked={providerByData === 'doctor-type'}
                                  aria-label={t(
                                    'member.price_comparison.provider_container.by_type_radio_ariaLabel',
                                  )}
                                />
                                <label
                                  htmlFor="doctor-type"
                                  className="location-filter-text"
                                >
                                  {t('member.price_comparison.doctor')}
                                </label>

                                <input
                                  className="my-auto ml-4"
                                  type="radio"
                                  name="location"
                                  id="doctor-name"
                                  value="doctor-name"
                                  onChange={(e) => {
                                    setTypesOfSpecialtyData('');
                                    e.target.checked
                                      ? setProviderByData('doctor-name')
                                      : setProviderByData('');
                                  }}
                                  checked={providerByData === 'doctor-name'}
                                  aria-label={t(
                                    'member.price_comparison.provider_container.by_name_radio_ariaLabel',
                                  )}
                                />
                                <label
                                  htmlFor="doctor-name"
                                  className="location-filter-text"
                                >
                                  {t('member.price_comparison.doctor_name')}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="types-or-specialty-container">
                            <span className="input-top-text">
                              {providerByData === 'doctor-type'
                                ? t('member.price_comparison.doctor')
                                : t('member.price_comparison.doctor_name')}{' '}
                            </span>
                            <AutoSuggestionSelectComponentAsync
                              placeholder={
                                providerByData === 'doctor-type'
                                  ? t(
                                      'member.price_comparison.label_placeholder_doctor',
                                    )
                                  : t(
                                      'member.price_comparison.label_placeholder_doctor_name',
                                    )
                              }
                              components={{ IndicatorSeparator: () => null }}
                              value={typesOfSpecialtyData}
                              onChange={(e) => {
                                setTypesOfSpecialtyData(e);
                              }}
                              //id="provider-type-specialty"
                              clearable={true}
                              inputClassName="generic-select-prefix__clear-indicator"
                              labelText={t(
                                'member.price_comparison.provider_container.type_or_specialty_dropdown_labelText',
                              )}
                              fetchOptions={searchNames}
                            />
                          </div>
                        </div>
                      </Tab>
                      <Tab
                        eventKey="Facility"
                        title={
                          <span className="tab-header">
                            {t('member.price_comparison.facility_label_tab')}
                          </span>
                        }
                      >
                        <div className="second-input-wrapper">
                          <div className="serach-container">
                            <div className="search-text-container">
                              {t('member.price_comparison.search')}
                            </div>
                            <div className="spaciality-by-container">
                              <div className="d-flex align-items-center">
                                <input
                                  className="my-auto"
                                  type="radio"
                                  name="location"
                                  id="facility-type"
                                  value="by-type"
                                  onChange={(e) => {
                                    setTypesOfSpecialtyData('');
                                    e.target.checked
                                      ? setProviderByData('facility-type')
                                      : setProviderByData('');
                                  }}
                                  checked={providerByData === 'facility-type'}
                                  aria-label={t(
                                    'member.price_comparison.provider_container.by_type_radio_ariaLabel',
                                  )}
                                />
                                <label
                                  htmlFor="facility-type"
                                  className="location-filter-text"
                                >
                                  {t('member.price_comparison.facility')}
                                </label>

                                <input
                                  className="my-auto ml-4"
                                  type="radio"
                                  name="location"
                                  id="facility-name"
                                  value="facility-name"
                                  onChange={(e) => {
                                    setTypesOfSpecialtyData('');
                                    e.target.checked
                                      ? setProviderByData('facility-name')
                                      : setProviderByData('');
                                  }}
                                  checked={providerByData === 'facility-name'}
                                  aria-label={t(
                                    'member.price_comparison.provider_container.by_name_radio_ariaLabel',
                                  )}
                                />
                                <label
                                  htmlFor="facility-name"
                                  className="location-filter-text"
                                >
                                  {t('member.price_comparison.facility_name')}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="types-or-specialty-container">
                            <span className="input-top-text">
                              {providerByData === 'facility-type'
                                ? t('member.price_comparison.facility')
                                : t(
                                    'member.price_comparison.facility_name',
                                  )}{' '}
                            </span>
                            <AutoSuggestionSelectComponentAsync
                              placeholder={
                                providerByData === 'facility-type'
                                  ? t('member.price_comparison.label_facility')
                                  : t(
                                      'member.price_comparison.label_facility_name',
                                    )
                              }
                              components={{ IndicatorSeparator: () => null }}
                              value={typesOfSpecialtyData}
                              onChange={(e) => {
                                setTypesOfSpecialtyData(e);
                              }}
                              //id="provider-type-specialty"
                              clearable={true}
                              inputClassName="generic-select-prefix__clear-indicator"
                              labelText={t(
                                'member.price_comparison.provider_container.type_or_specialty_dropdown_labelText',
                              )}
                              fetchOptions={searchFacilityNames}
                            />
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                    <div className="button-position">
                      <GenericButton
                        variant="link"
                        onClick={() => {
                          handleButton();
                        }}
                      >
                        {t('member.price_comparison.remove_provider')}
                      </GenericButton>
                    </div>
                  </div>
                )}
              </div>
            </ProviderContainerSearchPage>
          </>
        ) : (
          <PriceCompareSearchSkeleton />
        )}

        <div className="search-button-wrapper">
          <GenericButton
            variant="primary"
            onClick={() => {
              handleSearchResult();
            }}
            disabled={
              !(
                procedureForData?.value &&
                helthProcedureData?.value &&
                locationData
              )
            }
            //aria-label={t('member.price_comparison.search_btn_ariaLabel')}
            aria-label={
              !(
                procedureForData?.value &&
                helthProcedureData?.value &&
                locationData
              )
                ? 'Search button is disabled, select the services to search providers'
                : t('member.price_comparison.search_btn_ariaLabel')
            }
            aria-disabled={
              !(
                procedureForData?.value &&
                helthProcedureData?.value &&
                locationData
              ) && true
            }
          >
            {label}
          </GenericButton>
        </div>
        <div className="warning-parent mt-4">
          <div className="disclaimer-svg">
            <ConfigurationSVG.WarningSVG />
          </div>
          <div className="warning-content">
            <span className="content-bold">Disclaimer: {''}</span>
            <span className="disclaimer-text"> {disclaimerText}</span>
            {disclaimerText?.length > 80 && (
              <span className="button-position" aria-hidden={true}>
                <GenericButton
                  variant="link"
                  className="viewmore-btn"
                  onClick={() => {
                    setisOpenDisclaimerPopup(!isOpenDisclaimerPopup);
                  }}
                >
                  View More
                </GenericButton>
              </span>
            )}
          </div>
        </div>
        {isOpenDisclaimerPopup && (
          <div>
            <Modal
              show={isOpenDisclaimerPopup}
              onHide={handleClose}
              centered
              className={`Right-Model member generic-model`}
            >
              <Modal.Header closeButton className="plandocument-header">
                <Container className="px-0">
                  <Row className="align-items-center p-0 m-0">
                    <Col className="px-0">
                      <Modal.Title>Disclaimer</Modal.Title>
                    </Col>
                  </Row>
                </Container>
              </Modal.Header>

              <Modal.Body className="disclaimer-body">
                <Container className="px-0 custom-scroller modal-content-container pl-4 disclaimer-modal-container">
                  <div className="warning-content">{disclaimerText}</div>
                </Container>
              </Modal.Body>

              <Modal.Footer className="admin bg-white footer-class disclaimer-footer-btn">
                <div className="model-footer-btn txt-right p-0 m-0 border-0">
                  {/*<GenericButton
                  className="p-0 m-0"
                  onClick={() => handleClose()}
                >
                  {t('label_cancel')}
                </GenericButton> */}
                  <button onClick={() => handleClose()} className="close-btn">
                    Close
                  </button>
                </div>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceCompareSearch;
